<header class="site-header header-transparent header2">
  <!-- main header -->
  <div class="sticky-header main-bar-wraper navbar-expand-xl">
    <div class="main-bar clearfix">
      <div class="container-fluid clearfix">
        <!-- extra nav -->
        <div class="extra-nav">
          <div class="extra-cell">
            <ul>
              <li><a routerLink="/contact-us-{{data.profile}}"><span>Contact me?</span></a></li>
              <li><a href="javascript:void(0);" class="menu-btn active"><span>Menu</span>
                  <div class="menu"><span></span><span></span><span></span></div>
                </a></li>
            </ul>
          </div>
        </div>
        <!-- main nav -->
        <div class="header-nav icon-menu active">
          <ul class="nav navbar-nav">


            <li *ngFor="let menuData of menu_item" routerLinkActive="active"><a
                routerLink="/{{menuData.link}}-{{data.profile}}"><i class="{{menuData.class}}"></i></a></li>


          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- main header END -->
</header>
